import { IApplicationState } from '../../types/redux';
import { ENewReviewStep } from '../../types/newReview';

export const selectNewReviewFormStep = (state: IApplicationState): ENewReviewStep => {
  return state.newReview.meta.step;
};
